import { IDeletedAppointment, IApiDeletedAppointment } from './IDeletedAppointment'

class Transformer {
    static transform (data: IApiDeletedAppointment) : IDeletedAppointment {
        return {
            blocks: data.blocks,
            category: data.category,
            deletedAt: data.deleted_at,
            id: data.id,
            isBirthday: data.is_birthday,
            isDeleted: data.is_deleted,
            isNewCustomer: data.is_new_customer,
            isNoShow: data.is_no_show,
            isOnline: data.is_online,
            isRepeat: data.is_repeat,
            notes: data.notes,
            paymentStatus: data.payment_status,
            startsAt: data.starts_at,
            customer: {
                uuid: data.customer.uuid,
                address: data.customer.address,
                email: data.customer.email,
                firstName: data.customer.first_name,
                fullName: data.customer.full_name,
                gender: data.customer.gender,
                id: data.customer.id,
                image: data.customer.image,
                isMan: data.customer.is_man,
                isWoman: !data.customer.is_man,
                invoiceInformation: {
                    city: data.customer.invoice_location,
                    name: data.customer.invoice_name,
                    postal: data.customer.invoice_postal,
                    street: data.customer.invoice_address,
                    vatNumber: data.customer.invoice_vat_number
                }
            }
        }
    }
}

export default Transformer